import React from "react";
import { useParams } from "react-router-dom";
import { useI18n } from "@/i18n";
import Seo from "@/components/Seo";
import RichBody from "@/components/RichBody";
import NotFound from "@/pages/NotFound";
import { usePage } from "@/lib/usePage";

export default function PageView() {
  const { slug } = useParams();
  const { lang } = useI18n();
  const { content, exists } = usePage(slug, {});

  if (!exists) return <NotFound />;

  const title = content.title || slug;
  return (
    <div className="pt-32 pb-24">
      <Seo lang={lang} path={`/p/${slug}`} title={`${title} — HORS SIGNAL`} description={content.seo_description || `${title} — HORS SIGNAL.`} />
      <div className="mx-auto max-w-3xl px-6 sm:px-12">
        <h1 className="font-clash font-bold text-4xl sm:text-6xl uppercase tracking-tight" data-testid="custom-page-title">{title}</h1>
        <RichBody text={content.body} />
      </div>
    </div>
  );
}
